import('./tank_dam.css')
import ValueBox from '../value_box/value_box'
import store from '../../../../store/store'
export default function TankDam(opts={}){
    BaseConstructor.call(this)
    let {options, container} = opts
    let elements = {}
    let context = this

    const DAM_OPTIONS = {
        size: 60,
        stroke: '#2d6889',
        fill: '#4995bf',
        buffer: 5
    }

    this.generate = () =>{
        let points = setPoints()

        elements.container = this.createElement('div', 'tank-dam-icon-container')
        $(elements.container).css({
            width:DAM_OPTIONS.size,
            height: DAM_OPTIONS.size
        })

        setPosition()

        $(elements.container).html(
            '<i class="fas fa-water"></i>'
        )
        
        $(document).find('#canvas').append(elements.container)

        
        if(options.box_values){
            setBoxes()
        }

        eventsHandler()
    }

    const setPosition = _ =>{
        $(elements.container).css({
            top: convertPosition(options.position[1], 'h'),
            left: convertPosition(options.position[0], 'w')
        })
    }

    const eventsHandler = _ =>{
        $(elements.container).on('click', _ =>{
            store.informationCardStore.setBlockStatus(true)
            store.informationCardStore.setObjType('tankdam')
            store.informationCardStore.setStationId(options.id)
            store.informationCardStore.updateCardPosition(elements.container)
        })
        $(elements.container).on('mouseleave', _ =>{
            if(!store.informationCardStore.getBlockStatus()){
                store.informationCardStore.setStationId(undefined)
            }
        })

        store.diagramStore.subscribe('PATH_UPDATE_POSITION', _path=>{
            setPosition()
        })
    }

    function generateImage(logo){
        let image = document.createElement('div')
        // image.classList.add("supporter-image-container")

        let img = new Image()
        img.src = logo
        // if(logo.title == 'ana'){
        //     $(img).css({"height": "35px"})
        // }
        $(image).append(img.outerHTML)
        console.log(image);
        return image

    }

    const setBoxes = (params) => {
        // let bbox = elements.container.getBBox()
        let res_direction = options.direction
        options.box_values.forEach(box=>{
            let {value, position, line,station_id} = box
            let valueBox = new ValueBox({
                container: container,
                options:{
                    station_id:station_id,
                    value:value,
                    line: line,
                    position:{
                        x: (res_direction === 'up' || res_direction === 'down' ) ? convertPosition(options.position[0], 'w') : calculateOffset[res_direction][position](convertPosition(options.position[0], 'w'), DAM_OPTIONS.size/2, DAM_OPTIONS.buffer),
                        y: (res_direction === 'left' || res_direction === 'right' ) ? convertPosition(options.position[1], 'h') : calculateOffset[res_direction][position](convertPosition(options.position[1], 'h'), DAM_OPTIONS.size/2, DAM_OPTIONS.buffer)
                    }
                }
            })
            valueBox.generate()
        })
    }

    const calculateOffset = {
        up: {
            montante: (value, size, offset) => value + size + offset,
            jusante: (value, size, offset) => value - size - offset,
            reservatorio: (value, size, offset) => value,
        },
        down: {
            montante: (value, size, offset) => value - size - offset,
            jusante: (value, size, offset) => value + size + offset,
            reservatorio: (value, size, offset) => value,
        },
        left: {
            montante: (value, size, offset) => value + size + offset,
            jusante: (value, size, offset) => value - size - offset,
            reservatorio: (value, size, offset) => value,
        },
        right: {
            montante: (value, size, offset) => value - size - offset,
            jusante: (value, size, offset) => value + size + offset,
            reservatorio: (value, size, offset) => value,
        }
        
    }

    const setPoints = () =>{
        //transform rotate esta com o ponto ancora bem mal configurado, nao possibiltando a ultilização
        let converted_position = options.position.map((x, index) => convertPosition(x, !index ? 'w' : 'h'))
        let size = DAM_OPTIONS.size

        switch(options.direction){
            case 'up':
                return [
                    [converted_position[0] - size, converted_position[1] - size],
                    [converted_position[0] + size, converted_position[1] - size],
                    [converted_position[0] + size/5, converted_position[1] + size],
                    [converted_position[0] - size/5, converted_position[1] + size],
                ]
            case 'left':
                return [
                    [converted_position[0] - size, converted_position[1] - size],
                    [converted_position[0] + size, converted_position[1] - size/5],
                    [converted_position[0] + size, converted_position[1] + size/5],
                    [converted_position[0] - size, converted_position[1] + size],
                ]
            case 'right':
                return [
                    [converted_position[0] - size, converted_position[1] - size/5],
                    [converted_position[0] + size, converted_position[1] - size],
                    [converted_position[0] + size, converted_position[1] + size],
                    [converted_position[0] - size, converted_position[1] + size/5],
                ]
            default: 
                return [
                    [converted_position[0] - size/5, converted_position[1] - size],
                    [converted_position[0] + size/5, converted_position[1] - size],
                    [converted_position[0] + size, converted_position[1] + size],
                    [converted_position[0] - size, converted_position[1] + size],
                ]
        }

        

    }

    this.update = () =>{

    }

    const convertPosition = (pos, type) =>{
        let container_w = $(container).width()
        let container_h = $(container).height()
        if(type == 'w'){
            return pos * container_w / 100
        } else {
            return pos * container_h / 100
        }
    }
}

TankDam.prototype = Object.create(BaseConstructor.prototype)